import React, { Component } from "react";
import {
    Table,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import 'react-block-ui/style.css';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const headerStyle = {
    padding: '0.5rem',
};
class OrderHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageHistory: 1
        };
    }
    handleDetailPageChange = (pageNumber) => {
        let page = parseInt(pageNumber || 1)
        return this.setState({ pageHistory: page }, this.searchOrderHistoryData(page));
    }
    searchOrderHistoryData = (page) => {
        this.props.searchOrderHistoryData();
    }
    confirmReceivedMoney = (res) => {
        this.props.confirmReceivedMoney(res)
    }
    ProcessConfirmClick = (res) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>THÔNG BÁO?</h1>
                        <p>Bạn chắc chắn muốn xác nhận tiền?
                  </p>
                        <button className="text-danger" onClick={() => {
                            this.confirmReceivedMoney(res)
                            onClose()
                        }}>Đồng ý</button>
                        <button onClick={onClose}>Hủy bỏ</button>
                    </div>
                )
            }
        });
    }
    closeTabHandle = () => {
        this.setState({
            page: 1
        }, () => {
            this.props.onClose();
        });
    }
    render() {
        const {
            orderHistory,
            isRequesting,
        } = this.props
        return (
            <div className="animated fadeIn">
                <Modal isOpen={this.props.isOpen} className={'modal-lg ' + this.props.className}>
                    <ModalHeader style={headerStyle}>
                        LỊCH SỬ GIAO HÀNG
                    </ModalHeader>
                    <ModalBody>
                        <BlockUi tag="div" blocking={isRequesting}>
                            <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                                <thead className="thead-default">
                                    <tr>
                                        <th scope="col" width="50" className="text-center">#</th>
                                        <th scope="col" className="text-left">Ngày</th>
                                        <th scope="col" className="text-left">Nhân viên</th>
                                        <th scope="col" className="text-left">Trạng thái</th>
                                        <th scope="col" className="text-left">Số tiền thu</th>
                                        <th scope="col" className="text-left">Xác nhận</th>
                                        <th scope="col" className="text-left">Ghi chú</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderHistory && !!orderHistory.length && (
                                        orderHistory.map((res, idx) => (
                                            <tr key={idx + 1}>
                                                <td className="text-center">{idx + 1}</td>
                                                <td className="text-left">
                                                    <Moment format="HH:mm DD/MM/YYYY">{`${res.NgayGiao}`}</Moment>
                                                </td>
                                                <td className="text-left">{res.TenNguoiGiao}</td>
                                                <td className="text-left">{res.TenTrangThai}</td>
                                                <td className="text-right font-weight-bold">{res.SoTienThu.toLocaleString()}</td>
                                                <td className="text-left">
                                                    <ButtonExt
                                                        size="sm"
                                                        color={res.DaNhanTien == 0 ? "danger" : "success"}
                                                        displayText={res.DaNhanTien == 0 ? "Chưa nhận" : "Đã nhận"}
                                                        iconClass="fa-check-square-o"
                                                        btnType={BtnType.Button}
                                                        btnClick={() => this.ProcessConfirmClick(res)}
                                                        permission={BtnPermissions.GiaoHang.CONFIRM_RECEIVED_MONEY} />
                                                </td>
                                                <td className="text-left">{res.GhiChu}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </BlockUi>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeTabHandle.bind(this)}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
export default OrderHistory


// WEBPACK FOOTER //
// ./src/views/Order/_OrderHistory.js